import React from 'react';
import Link from '@material-ui/core/Link';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import HelpIcon from '@material-ui/icons/Help';

import logo from 'assets/Logo_MigrationWiz Horizontal on Light.svg';

import useStyles from './Header.style';

const Header: React.FC = () => {
  const {
    headerContainer,
    header,
    headerLogoContainer,
    headerLogo,
    helpGroup,
    headerIconButton,
  } = useStyles();
  return (
    <AppBar position="static" elevation={0} className={headerContainer}>
      <Toolbar className={header}>
        <div className={headerLogoContainer}>
          <img src={logo} alt="MigrationWiz Logo" className={headerLogo} />
        </div>
        <div className={helpGroup}>
          <Link
            href="https://www.bittitan.com"
            variant="button"
            underline="always"
          >
            <IconButton
              color="primary"
              className={headerIconButton}
              aria-label="help"
            >
              <HelpIcon />
            </IconButton>
            Help
          </Link>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
